var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',[_c('canvas',{attrs:{"id":'infektionsRisikoChart_'+_vm.randomId,"height":_vm.maxHeight}})])])}
var staticRenderFns = []

export { render, staticRenderFns }